import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import { escapeProductTitle } from '../../utils/urlUtils';
import config from '@config';
import { formatPrice } from '@priceFormatter';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState(() => {
        const defaultMethod = config.Cart.paymentMethods.find(method => method.default);
        return defaultMethod ? defaultMethod.id : 'efectivo';
    });
    const [deliveryOption, setDeliveryOption] = useState(() => {
        const defaultOption = config.Cart.deliveryOptions.find(option => option.default);
        return defaultOption ? defaultOption.id : 'Envio';
    });
    const [address, setAddress] = useState('');
    
    // Cargar datos del cache al inicializar
    useEffect(() => {
        cargarContacto();
        cargarDatosUsuario();
    }, []);
    
    // Función para cargar datos del usuario desde localStorage
    const cargarDatosUsuario = () => {
        const datosUsuario = JSON.parse(localStorage.getItem('datosUsuario') || '{}');
        if (datosUsuario.nombre) setName(datosUsuario.nombre);
        if (datosUsuario.email) setEmail(datosUsuario.email);
        if (datosUsuario.telefono) setTelefono(datosUsuario.telefono);
        if (datosUsuario.address) setAddress(datosUsuario.address);
        if (datosUsuario.deliveryOption) setDeliveryOption(datosUsuario.deliveryOption);
        if (datosUsuario.paymentMethod) setPaymentMethod(datosUsuario.paymentMethod);
        if (datosUsuario.noteText) setNoteText(datosUsuario.noteText);
    };
    
    // Función para guardar datos del usuario en localStorage
    const guardarDatosUsuario = () => {
        const datosUsuario = {
            nombre: name,
            email: email,
            telefono: telefono,
            address: address,
            deliveryOption: deliveryOption,
            paymentMethod: paymentMethod,
            noteText: noteText
        };
        localStorage.setItem('datosUsuario', JSON.stringify(datosUsuario));
    };
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const handleWhatsappMessage = () => {
        const codigoDescuento = codigos.find(item => item.codigo === codigo.trim());
        let descuentoActualizado = 0;

        if (codigoDescuento) {
            descuentoActualizado = codigoDescuento.descuento;
            setCodigoValido(true);
        } else {
            setCodigoValido(false);
        }

        let totalPrice = 0;

        cartItems.forEach(item => {
            totalPrice += item.precio * item.cantidad;
        });

        // Obtener el precio de envío de la configuración
        const selectedDeliveryOption = config.Cart.deliveryOptions.find(option => option.id === deliveryOption);
        const shippingCost = selectedDeliveryOption ? selectedDeliveryOption.price : 0;

        let totalPriceWithDiscount = totalPrice - descuentoActualizado + shippingCost;
        if (totalPriceWithDiscount < 0) {
            totalPriceWithDiscount = 0;
        }

        const formattedTotalPrice = formatPrice(totalPriceWithDiscount);

        const phoneNumber = `${contactos.telefono}`;

        const cartDetails = cartItems.map((item) => (
            `\n✅ *${item.titulo}* \n       Cantidad: ${item.cantidad}\n       Precio: ${moneda} ${formatPrice(item.precio)} \n       ${item?.item}`
        ));

        let noteMessage = '';

        if (location.trim() !== '') {
            noteMessage += `\n✅ Ubicación: ${location}`;
        }

        if (name.trim() !== '') {
            noteMessage += `\n✅ Nombre: ${name}`;
        }

        if (noteText.trim() !== '') {
            noteMessage += `\n✅ Nota: ${noteText}`;
        }

        if (codigo.trim() !== '') {
            noteMessage += `\n✅ Codigo : ${codigo.trim()}\n✅ Descuento de : ${moneda} ${formatPrice(descuentoActualizado)}`;
        }

        // Añadir la dirección de entrega en el mensaje
        const entrega = deliveryOption === 'Envio' ? 
            `Dirección de entrega: ${address} (Costo de envío: ${moneda} ${formatPrice(shippingCost)})` : 
            'Retiro personalmente';

        const paymentMessage = paymentMethod === 'efectivo' ? 'Pago en efectivo' : 'Pago por transferencia bancaria';

        const message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n ${noteMessage}\n✅ ${entrega}\n✅ ${paymentMessage}\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
        // Guardar datos del usuario
        guardarDatosUsuario();
        setLocation('');
        setCodigo('');
        setDescuento(descuentoActualizado);
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };


    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        // Validar campos obligatorios
        const errors = [];
        
        if (config.Cart.requiredFields.nombre && !name.trim()) {
            errors.push('El nombre es obligatorio');
        }
        
        if (config.Cart.requiredFields.email && !email.trim()) {
            errors.push('El email es obligatorio');
        }
        
        if (config.Cart.requiredFields.telefono && !telefono.trim()) {
            errors.push('El teléfono es obligatorio');
        }
        
        if (deliveryOption === 'Envio' && config.Cart.requiredFields.direccion && !address.trim()) {
            errors.push('La dirección es obligatoria para envío a domicilio');
        }

        if (errors.length > 0) {
            setMensaje('');
            Swal.fire(
                'Campos requeridos',
                errors.join('\n'),
                'error'
            );
            return;
        }

        try {
            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    item: item?.item,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)

                }
            });
            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);
            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item?.precio * item?.cantidad;
            });

            // Obtener el precio de envío de la configuración
            const selectedDeliveryOption = config.Cart.deliveryOptions.find(option => option.id === deliveryOption);
            const shippingCost = selectedDeliveryOption ? selectedDeliveryOption.price : 0;

            // Obtener el descuento del código de descuento
            const codigoDescuento = codigos?.find(item => item?.codigo === codigo.trim());
            let descuentoCodigo = 0;

            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento?.descuento;
            }

            // Aplicar el descuento del código de descuento y agregar costo de envío
            const totalPriceWithDiscount = totalPrice - descuentoCodigo + shippingCost;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();

            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('email', email);
            formData.append('telefono', telefono);
            console.log('Valor de direccion:', address);

            const entrega = deliveryOption === 'Envio' ? address : 'Retiro en personalmente';
            formData.append('entrega', entrega);

            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo.trim());
            formData.append('tipoEnvio', deliveryOption);
            formData.append('estado', 'Pendiente');
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            console.log(entrega)
            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                // Guardar datos del usuario antes de limpiar
                guardarDatosUsuario();
                Swal.fire(
                    'Pedido enviado!',
                    data.mensaje,
                    'success'
                );
                setCodigo('')
                closeModal()
                closeModal2()
                clearCart()
                handleWhatsappMessage()


            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );

        }
    };
    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart' >
                                            <Anchor to={`/producto/${item?.idProducto}/${escapeProductTitle(item?.titulo)}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {Array.isArray(item?.item) ? 
                                                        item.item.map((sabor, index) => (
                                                            <span key={index}> {sabor}</span>
                                                        ))
                                                        : 
                                                        item?.item ? <span>{item.item}</span> : null
                                                    }
                                                </span>
                                                <strong>{moneda} {formatPrice(item?.precio)}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {formatPrice(totalPrice)}</h4>

                            <div className='deFLexBtns'>

                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por  WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                </button>

                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                {config.Cart.requiredFields.nombre && (
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                            // Guardar en cache después de un pequeño delay
                                            setTimeout(() => guardarDatosUsuario(), 500);
                                        }}
                                        placeholder='Nombre (obligatorio)'
                                        required
                                    />
                                )}
                                {config.Cart.requiredFields.email && (
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            setTimeout(() => guardarDatosUsuario(), 500);
                                        }}
                                        placeholder='Email (obligatorio)'
                                        required
                                    />
                                )}
                                {config.Cart.requiredFields.telefono && (
                                    <input
                                        type="number"
                                        id="telefono"
                                        value={telefono}
                                        onChange={(e) => {
                                            setTelefono(e.target.value);
                                            setTimeout(() => guardarDatosUsuario(), 500);
                                        }}
                                        placeholder='Telefono (obligatorio)'
                                        required
                                    />
                                )}
                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>

                                    {config.Cart.deliveryOptions.map((option) => (
                                        <div
                                            key={option.id}
                                            onClick={() => {
                                                setDeliveryOption(option.id);
                                                setTimeout(() => guardarDatosUsuario(), 500);
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                id={option.id}
                                                name="deliveryOption"
                                                value={option.id}
                                                checked={deliveryOption === option.id}
                                                onChange={() => {
                                                    setDeliveryOption(option.id);
                                                    setTimeout(() => guardarDatosUsuario(), 500);
                                                }}
                                            />
                                            <label htmlFor={option.id}>
                                                {option.label}
                                                {option.price > 0 && ` (+${moneda} ${formatPrice(option.price)})`}
                                            </label>
                                        </div>
                                    ))}

                                </div>
                                {deliveryOption === 'Envio' && config.Cart.requiredFields.direccion && (

                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={address}
                                        onChange={(e) => {
                                            setAddress(e.target.value);
                                            setTimeout(() => guardarDatosUsuario(), 500);
                                        }}
                                        placeholder="Ingresa tu dirección COMPLETA (obligatorio)"
                                        required
                                    />

                                )}
                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    {config.Cart.paymentMethods.map((method) => (
                                        <div key={method.id}>
                                            <input
                                                type="radio"
                                                id={method.id}
                                                name="paymentMethod"
                                                value={method.id}
                                                checked={paymentMethod === method.id}
                                                onChange={() => {
                                                    setPaymentMethod(method.id);
                                                    setTimeout(() => guardarDatosUsuario(), 500);
                                                }}
                                            />
                                            <label htmlFor={method.id}>{method.label}</label>
                                        </div>
                                    ))}
                                </div>
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Codigo de descuento (opcional)'
                                />
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => {
                                        setNoteText(e.target.value);
                                        setTimeout(() => guardarDatosUsuario(), 500);
                                    }}
                                />
                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => `${item.titulo}, x ${item.cantidad}, ${item.item},${item.categoria},${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                        readOnly
                                    />
                                </fieldset>


                            </div>
                            {mensaje ? (
                                <button type='button' className='btn' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crearPedido} className='btn'>
                                    Finalizar pedido
                                </button>
                            )}
                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
